{
  "theme": {
    "dark": "Dunkles Thema",
    "main": "Hauptthema"
  },
  "projectCustomisation": {
    "projectDetails": "Einzelheiten zum Projekt",
    "editDetails": "Einzelheiten bearbeiten",
    "projectName": "Name des Projekts",
    "projectNameHelperText": "Max. 24 Zeichen",
    "projectLogoTitle": "Logo des Projekts",
    "projectLogoHint": "Dieses Bild wird in der oberen Navigationsleiste und auf der Anmeldeseite des Projekts angezeigt",
    "projectLogoRemoveTitle": "Entferne das Logobild aus diesem Projekt",
    "projectLogoRemoveText": "Dadurch wird die Logo-Bilddatei entfernt und jeder, der Zugriff auf das Projekt hat, wird sie nicht mehr sehen. Sind Sie sicher, dass Sie fortfahren möchten?",
    "projectLogoRestrictionHint": "Die maximale Bildgröße beträgt 1920 Pixel (Höhe) und 1080 Pixel (Breite)",
    "projectImageTitle": "Bild projizieren",
    "projectImageHint": "Dieses Bild wird auf der Projektkarte und im Dashboard angezeigt",
    "projectImageRemoveTitle": "Entferne das Bild aus diesem Projekt",
    "projectImageRemoveText": "Dadurch wird die Bilddatei entfernt und jeder, der Zugriff auf das Projekt hat, wird sie nicht mehr sehen. Sind Sie sicher, dass Sie fortfahren möchten?",
    "projectImageRestrictionHint": "Die maximale Bildgröße beträgt 1920 Pixel (Höhe) und 1080 Pixel (Breite)"
  },
  "scheduleConfig": {
    "title": "Konfiguration planen",
    "description": "Der Zeitplan kann mithilfe der folgenden Einstellungen konfiguriert werden. Nehmen Sie hier nur Änderungen vor, wenn Sie genau wissen, wie die Zeitplankonfiguration funktioniert. Wenn Sie sich nicht sicher sind, wenden Sie sich an den Iventis-Support:",
    "save": "Speichern Sie die Änderungen im Zeitplan",
    "timesAndDates": "Zeiten und Daten",
    "venueTypeHierarchy": "Hierarchie der Art des Veranstaltungsorts",
    "scheduleVersionHierarchy": "Hierarchie der Versionen des Zeitplans",
    "eventBlockHierarchy": "Hierarchie des Event-Blocks",
    "venueRunSheets": "Veranstaltungskalender (DCAS)",
    "timezone": "Zeitzone",
    "dayStartTime": "Startzeit für jeden Tag",
    "dayEndTime": "Endzeit für jeden Tag",
    "projectStartDate": "Startdatum des Projekts",
    "projectEndDate": "Enddatum des Projekts",
    "projectZeroDate": "Projekttag 0",
    "eventBlockTitleTop": "Veranstaltungsblöcke im Kalender der obersten Ebene",
    "eventBlockTitleSecond": "Kalenderereignisblöcke der zweiten Ebene",
    "eventBlockTitleThird": "Kalenderereignisblock auf dritter Ebene",
    "eventBlockTitleDefault": "Kalenderereignisblock auf Ebene",
    "eventBlockTypeName": "Name des Typs des Event-Blocks",
    "eventBlockApiSingle": "API-Name Singular",
    "eventBlockApiPlural": "API-Name im Plural",
    "eventBlockAllowedVenueTypes": "Zulässige Arten von Veranstaltungsorten",
    "eventBlockRelativeTypes": "Kann relativ zu Typen sein",
    "eventBlockSummaryText": "Attribute des untergeordneten Event-Blocks, die in der Zusammenfassung verwendet werden sollen",
    "eventBlockDCAS": "Kann innerhalb des DCAS erstellt werden",
    "eventBlockCustomerIdentifier": "Kunden-ID",
    "clusterVenueLocationTemplateTitle": "Vorlage für den Standort eines Cluster-Veranstaltungsorts",
    "mainVenueLocationTemplateTitle": "Vorlage für den Standort des Hauptveranstaltungsortes",
    "subVenueLocationTemplateTitle": "Vorlage für den Standort eines Nebenveranstaltungsortes",
    "enableClusters": "Cluster aktivieren",
    "editVenues": "Veranstaltungsorte bearbeiten",
    "venueLocations": "Standorte der Veranstaltungsorte",
    "venueLocationTypeName": "Ort, Typ, Name des Veranstaltungsorts",
    "attributes": "Attribute",
    "scheduleVersionTopLevelTitle": "Version des Zeitplans auf oberster Ebene",
    "scheduleVersionSecondLevelTitle": "Version des Zeitplans der zweiten Ebene",
    "scheduleVersionLevelTitle": "Version des Zeitplans der Ebene",
    "scheduleVersionName": "Name der Version des Zeitplans",
    "problems": "Es gibt {{ problemCount }} Probleme mit der übermittelten Zeitplankonfiguration",
    "dcasEventBlock": "Event-Block für Run Sheet",
    "dcasEventBlockQuestion": "Aktivieren Sie den Eventblock „Nur Run-Sheet“",
    "dcasEventBlockCalendar": "Zu verwendende Event-Blöcke",
    "dcasEventBlockAttributes": "Attribute für Run Sheet",
    "dcasEnableDone": "Markieren Sie Aktivitäten mit „Erledigt“",
    "calendarLevel": {
      "0": "Sitzung",
      "1": "geplantes Objekt",
      "activity": "Aktivität"
    }
  }
}